const ispSportsAliases = [
  'sportsAnimalRacingFuture',
  'sportsAnimalRacingFutureMarket',
  'sportsAnimalRacingMeetings',
  'sportsAnimalRacingNext',
  'sportsAnimalRacingRace',
  'sportsAnimalRacingSpecials',
  'sportsCompetition',
  'sportsCompetitionOutrights',
  'sportsCompetitions',
  'sportsEmbeddedHistoricalBets',
  'sportsEmbeddedMyBets',
  'sportsEmbeddedSettings',
  'sportsEvent',
  'sportsGolfCompetitions',
  'sportsGolfMatches',
  'sportsHistoricalBets',
  'sportsHome',
  'sportsInPlay',
  'sportsInPlaySport',
  'sportsLanding',
  'sportsMatchFiltering',
  'sportsMyBets',
  'sportsPromotion',
  'sportsPromotions',
  'sportsSelfExcluded',
  'sportsSelfExcludedHistoricalBets',
  'sportsSelfExcludedMyBets',
  'sportsSettings',
  'sportsSpecials',
  'sportsSport',
  'sportsTennisCompetition',
  'sportsSportInPlay'
] as const;
export type IspSportsAlias = (typeof ispSportsAliases)[number];
export const isIspSportsAlias = (alias: string): alias is IspSportsAlias =>
  ispSportsAliases.includes(alias);
